import * as React from "react";
const SvgFiRrFamilyDress = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-family-dress_svg__a)">
      <path
        fill="#062147"
        d="M9.5 7.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M16 14v3c0 .883-.39 1.67-1 2.22V23a1 1 0 1 1-2 0v-3h-2v3a1 1 0 1 1-2 0v-3.78A2.98 2.98 0 0 1 8 17v-3c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3m-3 4a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2c-.55 0-1 .448-1 1v3c0 .552.45 1 1 1zm6-13a2.5 2.5 0 1 0 .001-5 2.5 2.5 0 0 0 0 5m4.977 11.628-.876-7.008a4.14 4.14 0 0 0-4.1-3.62c-.963 0-1.899.338-2.64.952a1 1 0 0 0 1.277 1.539A2.14 2.14 0 0 1 19 8c1.073 0 1.983.803 2.116 1.868l.876 7.008a1 1 0 0 1-.242.786A.99.99 0 0 1 21 18h-3a1 1 0 1 0 0 2h2v3a1 1 0 1 0 2 0v-3.189a3 3 0 0 0 1.25-.826 3 3 0 0 0 .728-2.357M5 5a2.5 2.5 0 1 0 .001-5 2.5 2.5 0 0 0 0 5m0 1A4.14 4.14 0 0 0 .9 9.62l-.877 7.008a3 3 0 0 0 .728 2.357c.34.385.775.657 1.25.826V23a1 1 0 1 0 2 0v-3h2a1 1 0 1 0 0-2H3a.99.99 0 0 1-.75-.338 1 1 0 0 1-.244-.786l.876-7.008A2.136 2.136 0 0 1 5 8c.496 0 .98.175 1.361.491a1 1 0 1 0 1.277-1.539A4.14 4.14 0 0 0 4.998 6z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-family-dress_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFamilyDress;
